/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * Normalizes experimentId with fallback logic and ACES awareness.
 *
 * Behavior:
 * - When acesEnabled is false: returns undefined (experimentId doesn't apply)
 * - When experimentId is 'lucid': returns 'elasticsearch' (lucid is deprecated)
 * - When experimentId is undefined: returns 'elasticsearch' (default)
 * - Otherwise: returns experimentId as-is
 *
 * @param rawExperimentId - Raw experimentId from Monetate (can be string for backwards compatibility)
 * @param acesEnabled - Whether ACES system is enabled
 * @returns Normalized experimentId or undefined
 */
export function getExperimentId(
  rawExperimentId: string | undefined,
  acesEnabled: boolean,
): 'elasticsearch' | 'vertex' | undefined {
  if (!acesEnabled) {
    return undefined;
  }

  if (rawExperimentId === 'lucid') {
    return 'elasticsearch';
  }

  if (rawExperimentId === 'vertex' || rawExperimentId === 'elasticsearch') {
    return rawExperimentId;
  }

  return 'elasticsearch';
}
